import type { IValues } from '../valuesTypes';

import classNames from 'classnames';

import { useState, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { screenedValues } from '../../../tools/constants';
import { useTranslation } from 'react-i18next';

export const InternetSpeed = ({
    handler,
    editable = true,
}: {
    handler?: (step: number) => void;
    editable?: boolean;
}) => {
    const { values, errors, touched, submitCount } = useFormikContext<IValues>();
    const { t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const isFormCompleted = useMemo(
        () => ['internetSpeed', 'numberOfCandidateTestingStations'].every(field => !errors[field as keyof IValues] && touched[field as keyof IValues]),
        [errors, touched]
    );

    return (
        <div
            className={classNames('cco_collapse', {
                active: isExpanded,
            })}
        >
            <div className="cco_collapse_header">
                <div className="cco_text cco_text_3">
                    <div className="cco_text_inner">
                        <h3>5. {t('NewLocation.TestingSite.TestSiteCapacity')}</h3>

                        <div
                            className={classNames({
                                success: isFormCompleted,
                                error: !isFormCompleted,
                            })}
                        >
                            {isFormCompleted
                                ? t('NewLocation.TestingSite.Completed') 
                                : submitCount < 1
                                ?  t('NewLocation.TestingSite.InProgress') 
                                : t('NewLocation.TestingSite.FillFields')}
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className="cco_collapse_toggle"
                    onClick={() => setIsExpanded(prevState => !prevState)}
                >
                    <span className="cco_collapse_toggle_text">{t('NewLocation.TestingSite.View')}</span>
                </button>
            </div>

            <div className="cco_collapse_body">
                <div className="cco_collapse_body_inner">
                    <div className="cco_blurb cco_blurb_1">
                        <div className="cco_blurb_label">{t('NewLocation.TestingSite.Testingstations')}</div>
                        <div className="cco_blurb_value">
                            <strong>{values.numberOfCandidateTestingStations || t('NewLocation.TestingSite.NotCompleted')}</strong>
                        </div>
                    </div>

                    <div
                        className={classNames('cco_blurb cco_blurb_3', {
                            cco_blurb_success: 'yes' === values.internetSpeed,
                            cco_blurb_error: 'no' === values.internetSpeed,
                        })}
                    >
                        <div>
                            <p>   {    t('NewLocation.TestingSite.NoAnswer')}</p>

                            {'default' === values.internetSpeed && (
                                <p className="cco_blurb cco_blurb_3 cco_blurb_error cco_form_message_error_footer">
                                  {    t('NewLocation.TestingSite.Requir')}
                                </p>
                            )}
                        </div>
                    </div>

                    {editable && (
                        <div className="cco_btn cco_btn_2">
                            <a
                                href="#"
                                onClick={e => {
                                    handler?.(1);
                                    e.preventDefault();
                                }}
                            >
                               {
                            
                                t('NewLocation.TestingSite.Edit')}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
